import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { auth } from "../../firebase";
import { getMyImpactNetworks } from "../../services/impactNetworks";
import "./ImpactNetworks.css";

export default function MyImpactNetworks() {
  const user = auth.currentUser;
  const [networks, setNetworks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadNetworks() {
      if (!user?.uid) {
        setLoading(false);
        return;
      }

      const data = await getMyImpactNetworks(user.uid);
      setNetworks(data);
      setLoading(false);
    }

    loadNetworks();
  }, [user?.uid]);

  if (!user) {
    return (
      <div className="impact-network-page">
        Please log in to view your Impact Networks.
      </div>
    );
  }

  if (loading) {
    return (
      <div className="impact-network-page">
        Loading your Impact Networks...
      </div>
    );
  }

  return (
    <div className="impact-network-page">
      <nav className="network-top-nav">
        <Link to="/" className="network-brand-link">
          somebody.gives
        </Link>

        <div className="network-top-nav-links">
          <Link to="/give/dashboard">My Dashboard</Link>
          <Link to="/give/browse">Browse Needs</Link>
        </div>
      </nav>

      <section className="network-hero">
        <div>
          <div className="network-eyebrow">Collective Giving</div>
          <h1>My Impact Networks</h1>
          <p className="network-hero-text">
            Join groups, invite members, and track the recurring needs your
            community is helping support.
          </p>
          <p className="network-hero-subtext">
            You belong to {networks.length} Impact Network
            {networks.length === 1 ? "" : "s"}.
          </p>
        </div>

        <Link
          className="network-secondary-button"
          to="/donor/impact-networks/create"
        >
          Create Network
        </Link>
      </section>

      {networks.length === 0 ? (
        <section className="network-panel">
          <div className="network-eyebrow">Start Here</div>
          <h2>No Impact Networks Yet</h2>
          <p>
            Join a network through an invite link or create one for your group.
          </p>

          <Link
            className="network-inline-button"
            to="/donor/impact-networks/create"
          >
            Create an Impact Network
          </Link>
        </section>
      ) : (
        <section className="network-panel">
          <div className="network-eyebrow">Your Groups</div>
          <h2>Impact Networks</h2>

          <div className="network-commitment-grid">
            {networks.map((network) => (
              <Link
                className="network-list-card"
                key={network.networkId || network.id}
                to={`/donor/impact-networks/${network.networkId || network.id}`}
              >
                <div className="network-list-card-top">
                  <div className="network-avatar">
                    {(network.name || "N").charAt(0).toUpperCase()}
                  </div>

                  <div>
                    <h3>{network.name}</h3>
                    <p>{network.role || "member"}</p>
                  </div>
                </div>

                <span>View impact →</span>
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}